
export function computeAutoAlignedSliderValue({
  currentValue,
  sourceSectionTotal,
  otherSectionTotal,
  totalBudgetCap,
}) {
  const current = Number(currentValue) || 0;
  const sourceTotal = Number(sourceSectionTotal) || 0;
  const otherTotal = Number(otherSectionTotal) || 0;
  const gap = otherTotal - sourceTotal;
  const ideal = current + gap;
  return Math.min(Math.max(0, ideal));
}
